<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>停车管理</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/garage' }">车库管理</el-breadcrumb-item>
            <el-breadcrumb-item>车库下发</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <div style="display:flex;align-items:center;justify-content:space-between;width:100%">
              <div style="display:flex;align-items:center;margin-right:20px;width:30%;justify-content:space-between;">
                <el-select
                v-model="logout"
                clearable
                filterable
                placeholder="请选择状态"
                class="select"
                @change="search">
            <el-option
              v-for="item in stutas"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
           </el-select>
                <el-input v-model="carNumber" placeholder="搜索车牌号" style="width:200px" clearable>
                  <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                </el-input>
              </div>
              <div style="display:flex;align-items:center;justify-content:space-between;">
                <!-- <el-button
                  type="primary"
                  size="mini"
                  style="display:flex;align-items:center"
                  @click="send()"
                >批量下发</el-button> -->
                <el-tooltip class="item" effect="dark" content="批量下发" placement="top-end">
                  <img @click="send()" class="icon_hover" src="../../assets/image/xiafa.png" alt="" srcset="">
               </el-tooltip>
              </div>
            </div>
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table
              stripe
              :data="tableData"
              height="100%"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
              @selection-change="handleSelectionChange"
            >
             <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column type="selection" width="55" :selectable="selectable" ></el-table-column>
          <el-table-column label="编号">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="车牌号">
            <template slot-scope="scope">
              <span>{{scope.row.carNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column label="车牌类型">
            <template slot-scope="scope">
              <span>{{ scope.row.carType }}</span>
            </template>
          </el-table-column>
          <el-table-column label="车主">
            <template slot-scope="scope">
              <span>{{scope.row.personName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机号">
            <template slot-scope="scope">
              <span>{{scope.row.phone}}</span>
            </template>
          </el-table-column>
          <el-table-column label="有效期">
            <template slot-scope="scope">
              <span>{{scope.row.endTime}}</span>
            </template>
          </el-table-column>
          <el-table-column label="登记时间">
            <template slot-scope="scope">
              <span>{{scope.row.starTime}}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属车库">
            <template slot-scope="scope">
              <span>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span style="color:green" v-if="scope.row.logout==0">有效</span>
              <span style="color:red" v-if="scope.row.logout==1">无效</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <div v-if="scope.row.logout==0" class="minibtn">
                <el-button type="text" size="mini" @click="editFun(scope.row)">编辑</el-button>
                <el-button type="text" size="mini" @click="logOut(scope.row.carId)">注销</el-button>
              </div>
              <span v-if="scope.row.logout==1" style="color:#C4C4C4">已注销</span>
              <span
                v-if="scope.row.logout==2"
                style="color:#1BD095"
                @click="wait(scope.row)"
                class="hand"
              >待审核</span>
              <span v-if="scope.row.logout==3" style="color:#f00">未通过</span>
            </template>
          </el-table-column>-->
          <!-- 编辑窗口 -->
          <el-dialog
            :title="dialogTitle"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :before-close="handleClose"
            :lock-scroll="false"
            width="30%"
          >
            <el-form :model="editForm" ref="editForm">
              <el-form-item label="车主:">
                <el-input v-model="editForm.personName" autocomplete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="车牌类型:">
                <el-input v-model="editForm.carType " autocomplete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="登记时间:">
                <el-input v-model="editForm.starTime " autocomplete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="手机号:">
                <el-input v-model="editForm.phone " type="number" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="有效时间:">
                <el-date-picker
                  v-model="editForm.endTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="editFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitAddRow('editForm')">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 审核 -->
          <el-dialog
            :title="dialogTitle"
            :visible.sync="waitFormVisible1"
            center
            :append-to-body="true"
            :before-close="handleClose1"
            :lock-scroll="false"
            width="30%"
          >
            <el-form :model="waitForm" ref="waitForm">
              <el-form-item label="车主:">
                <el-input v-model="waitForm.personName" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="车牌类型:">
                <el-input v-model="waitForm.carType " autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="行驶证:">
                <img :src="icon" class="avatar" />
              </el-form-item>
              <el-form-item label="有效期:">
                <el-date-picker
                  v-model="waitForm.endTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="登记时间:">
                <el-date-picker
                  v-model="waitForm.starTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  disabled
                ></el-date-picker>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="argeeNot('waitForm')">不同意</el-button>
              <el-button type="primary" @click="argee('waitForm')">同 意</el-button>
            </div>
          </el-dialog>
          <!-- 下发列表 -->
          <el-dialog
            :title="dialogTitle1"
            :visible.sync="issueVisible"
            center
            :append-to-body="true"
            :before-close="handleClose2"
            :lock-scroll="false"
            width="30%"
          >
            <template>
              <el-table
                :data="tableData1"
                style="width: 100%"
                border
                @selection-change="handleSelectionChange1"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="序列号" width="300">
                  <template slot-scope="scope">
                    <span>{{scope.row.serialno}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="reason" label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.direction==1" style="color:#07C160">进闸</span>
                    <span v-if="scope.row.direction==2" style="color:#f00">出闸</span>
                  </template>
                </el-table-column>
              </el-table>
              <div slot="footer" class="dialog-footer">
                <el-button @click="issueVisible = false">取消</el-button>
                <el-button type="primary" @click="issue()">下发</el-button>
              </div>
            </template>
          </el-dialog>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100, 500, 1000]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      tableData: [], //获取数据
      tableData1: [],
      currentPage: 1,
      pageSize: 500,
      totalItems: 0,
      projectId: '',
      serchName: '', //车库名称
      dataText: '暂无数据',
      uploadUrl1: myHttp.uploadPhoto, //上传地址
      uploadHead1: {
        accessToken: util.session.get('token')
      },
      editFormVisible: false,
      waitFormVisible1: false,
      waitForm: {
        personId: '',
        personName: '',
        carType: '',
        drivingPermit: ' ',
        id: ' ',
        starTime: '',
        endTime: ''
      },
      dialogTitle: '',
      dialogTitle1: '下发车牌列表',
      editForm: {
        personId: '',
        id: '',
        carType: '',
        starTime: '',
        endTime: '',
        phone: ''
      },
      icon: '', // 行驶证图
      updateBy: '',
      userId: '',
      stutas: [
        { value: '0', name: '有效' },
        { value: '1', name: '无效' }
      ],
      logout: '',
      carNumber: '', //车牌号
      multipleSelection: [],
      attendVisible: false,
      issueVisible: false,
      attendData: [],
      attendData1: [],
      licenseIds: '', //车牌id
      cars: [],
      carportId: '', //车库id
      imeis: ''
    }
  },
  mounted() {
    this.projectId = util.session.get('groupId')
    this.userId = util.session.get('user').id
    this.updateBy = util.session.get('user').id
    if (this.projectId == '') {
      this.$store.commit('setGroupId')
      this.projectId = this.$store.state.groupId
    }
    this.carportId = this.$route.params.id
    // this.getList()
    // console.log(this.$store.state.token)
    // this.getCar()
    this.getData()
  },
  methods: {
    //获取数据
    getData() {
      var that = this
      myHttp
        .secCarByCarportIdAndLogoutPage({
          carportId: this.carportId,
          carNumber: this.carNumber,
          logout: this.logout,
          pageSize: this.pageSize,
          pageNum: this.currentPage
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              console.log(resp)
              var list = resp.data.data.licenses.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].index =
                  that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
              }
              that.tableData = list
              that.totalItems = resp.data.data.licenses.total
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },

    doFilter() {
      this.getData()
    },
    //
    handleChange(e) {
      this.editForm.useType = e.value
      // console.log(e.value)
    },

    search() {
      this.getData()
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.editFormVisible = false
    },
    handleClose1(done) {
      this.waitFormVisible1 = false
    },
    handleClose2(done) {
      this.issueVisible = false
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      for (var i = 0; i < this.multipleSelection.length; i++) {
        if (i == 0) {
          this.licenseIds = this.multipleSelection[i].carId
        } else {
          this.licenseIds += ',' + this.multipleSelection[i].carId
        }
        console.log(this.licenseIds)
      }
    },
    // 下发列表多选框
    handleSelectionChange1(val) {
      for (var i = 0; i < val.length; i++) {
        if (i == 0) {
          this.imeis = val[i].serialno
        } else {
          this.imeis += ',' + val[i].serialno
        }
        console.log(this.imeis)
      }
    },
    // 批量下发
    send() {
      var that = this
      if (this.multipleSelection.length == '0') {
        that.$message({
          type: 'warning',
          message: '请选择需要下发的车牌号!'
        })
        return
      }
      this.issueVisible = true
      myHttp
        .secCameraByCarportId({
          carportId: this.carportId
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              console.log(resp)
              that.tableData1 = resp.data.data || []
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    issue() {
      //   this.$confirm('此操作将下发车库, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(() => {
      //     myHttp
      //       .sendTemplate({
      //         licenseIds: this.licenseIds,
      //         carportId: this.carportId,
      //         projectId: this.projectId
      //       })
      //       .then(function(resp) {
      //         if (resp.data.code == '200') {
      //           that.$message({
      //             type: 'success',
      //             message: '下发成功!'
      //           })
      //           that.getData()
      //         } else {
      //           that.$message.error(resp.data.msg)
      //         }
      //       })
      //   })
      //   .catch(err => {})
      var that = this
      if (!this.imeis) {
        that.$message({
          type: 'warning',
          message: '请选择需要下发的序列号!'
        })
        return
      }
      this.issueVisible = true
      myHttp
        .sendTemplate({
          licenseIds: this.licenseIds,
          imeis: this.imeis,
          projectId: this.projectId
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              that.$message({
                type: 'success',
                message: '下发成功!'
              })
              that.issueVisible = false
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    selectable(row) {
      // console.log(row.logout)
      if (row.logout == '1') {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
  overflow: auto;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px 10px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 127px);
  width: 98%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.cur {
  background: #ecf5ff !important;
  /* border: 1px solid   #409EFF !important ; */
  color: #409eff !important  ;
}
.color1{
  color: #409eff;
  cursor: pointer;
}
</style>